"use client";

import React, { memo, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  H4,
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography";

import SalifyFallback from "src/lib/components/salify-fallback/default";
import { Grid } from "@mui/material";
import clientFetcher from "src/lib/fetcher/client";
import ProductItemHorizontal from "src/lib/components/product-item/horizontal";
import { StyledNavbarLinkItem } from "src/lib/components/category-section/bazaar/styles";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import Image from "next/image";
import { toAssetImages } from "src/lib/utils";
import { customBgColor } from "src/lib/components/category-section/bazaar/side-nav-bar";
import Card from "@mui/material/Card";

// ==================================================================
const CategoryItem = ({ item, ind, isSelected = false, handleClick }) => (
  <StyledNavbarLinkItem mb="2px" color="grey.700" key={ind} isSelected={isSelected}>
    <Box
      key={item.id}
      sx={{
        color: "grey.700",
        cursor: "pointer",
      }}
    >
      <FlexBox
        gap={1.5}
        className="linkList"
        py={0.75}
        sx={{
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
        onClick={handleClick}
      >
        <Image
          alt={item.code}
          width={20}
          height={20}
          src={
            item.imageUrlIcon
              ? toAssetImages(item.imageUrlIcon)
              : "/assets/images/06f2ae32-86a2-45ea-bce3-09182a5b9b5d/t-thumb.jpeg"
          }
          style={{
            height: 28,
            width: 28,
            padding: 6,
            borderRadius: 8,
            objectFit: "contain",
            background: customBgColor[ind % customBgColor.length],
          }}
        />
        <Span fontWeight={600} fontSize={12}>
          {item.name}
        </Span>
      </FlexBox>
    </Box>
  </StyledNavbarLinkItem>
);

const CategoryMobileMenu = (props) => {
  const { isFixed, navList, sidebarHeight = "auto", sidebarStyle = "style1" } = props;
  const [selectedCategory, setSelectedCategory] = useState(navList[0]?.id);
  const [products, setProducts] = useState([]);

  const fetchProducts = async (category) => {
    return clientFetcher.queryProducts(category);
  };

  useEffect(() => {
    if (!selectedCategory) {
      return;
    }
    fetchProducts(selectedCategory).then((data) => setProducts(data));
  }, [selectedCategory]);
  return (
    <Card
      sx={{
        overflow: "auto",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
      }}
    >
      <Box
        padding="16px"
        sx={{
          position: "absolute",
          background: "#fff",
          zIndex: "1201",
          width: "100%",
          borderTopRadius: "inherit",
          // borderTopRightRadius: "inherit",
        }}
      >
        <Paragraph fontSize={14} fontWeight={600}>
          <SalifyFallback.Label path="Categories" default="Danh mục sản phẩm" />
        </Paragraph>
      </Box>

      <Grid container sx={{ marginTop: "56px" }}>
        <Grid item xs={3}>
          {navList.map((item, ind) => (
            <CategoryItem
              key={item.code}
              item={item}
              ind={ind}
              isSelected={item.id === selectedCategory}
              handleClick={() => setSelectedCategory(item.id)}
            />
          ))}
        </Grid>

        <Grid item xs={9} sx={{ padding: "1rem", background: "#F2F2F5" }}>
          <H4>{navList.find((cat) => cat.id === selectedCategory)?.name}</H4>
          {products.map((item, ind) => (
            <ProductItemHorizontal key={item.code} {...item} sx={{ marginY: 1 }} />
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};

export default memo(CategoryMobileMenu);
